import React from 'react';
import MarketIcon from '../../assets/images/market.png'
import PortfolioIcon from '../../assets/images/portfolio.png'
import NewsIcon from '../../assets/images/news.png'
import TeamIcon from '../../assets/images/equipo-tab.png'
import '../street/street-tab-bar.css';

const WallStreetTabs = (props) => {
    return(
        <div className="street-tabs">
                <div onClick={()=>props.handleTabChange("market")}>
                    <img src={MarketIcon} className="street-tab"></img>
                </div>
                <div onClick={()=>props.handleTabChange("portfolio")}>
                    <img src={PortfolioIcon} className="street-tab"></img>
                </div>
                <div onClick={()=>props.handleTabChange("news")}>
                    <img src={NewsIcon} className="street-tab"></img>
                </div>
                <div onClick={()=>props.handleTabChange("summary")}>
                    <img src={TeamIcon} className="street-tab"></img>
                </div>

        </div>
    )
}

export default WallStreetTabs;